import React from 'react';
import { CalendarRange } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';

/**
 * Play-format picker for the meta page.
 *
 * A format starts the day a set releases and the meta resets with it, so the
 * current format is the default and earlier ones are kept for reference. Newest
 * first. Renders nothing until there is an earlier format to go back to.
 */
export default function FormatSwitcher({ format, formats, onChange, className = '' }) {
  const { t } = useLanguage();
  if (!formats || formats.length < 2) return null;

  const labelText = t('meta.formatLabel');
  const ordered = [...formats].sort((a, b) => (b.start || '').localeCompare(a.start || ''));

  return (
    <label className={`flex items-center gap-2 ${className}`}>
      <span className="sr-only">{labelText}</span>
      <CalendarRange aria-hidden="true" className="h-4 w-4 text-white/80" />
      <select
        aria-label={labelText}
        className="h-9 rounded-md border border-white/30 bg-white/10 px-3 text-sm text-white [&>option]:text-foreground"
        value={format || ''}
        onChange={(event) => onChange(event.target.value)}
      >
        {ordered.map((f) => (
          <option key={f.id} value={f.id}>
            {t(f.current ? 'meta.formatCurrent' : 'meta.formatOption', { format: f.id })}
          </option>
        ))}
      </select>
    </label>
  );
}
